// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__fJIPS","row":"ProcedureTreatmentSummary_row__kQdpG"};